import { ApiAddress } from '@/services/apis'
import { ID } from '@/services/common.model'
import request from '@/services/request'
import { Terms } from './terms.model'

export function createOrganizationTerm(id: ID, tId: ID, data: Terms.Create) {
  return request.post(ApiAddress.ORGANIZATION_TERMS_LIBRARY_TERMS, data, { params: { id, tId } })
}

export function getOrganizationTermsList(id: ID): Promise<Terms.Info[]> {
  return request.get(ApiAddress.ORGANIZATION_TERMS, { params: { id } })
}

export function getTerms(id: ID): Promise<Terms.Info> {
  return request.get(ApiAddress.TERM, { params: { id } })
}

export function updateTerms(id: ID, body: Terms.Create) {
  return request.put(ApiAddress.TERM, body, { params: { id } })
}

export function deleteTerms(id: ID) {
  return request.delete(ApiAddress.TERM, { params: { id } })
}
